import { render, staticRenderFns } from "./EditingLimit.vue?vue&type=template&id=021a8515&scoped=true"
import script from "./EditingLimit.vue?vue&type=script&lang=js"
export * from "./EditingLimit.vue?vue&type=script&lang=js"
import style0 from "./EditingLimit.vue?vue&type=style&index=0&id=021a8515&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a8515",
  null
  
)

export default component.exports